<template>
  <OareDialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    title="Verify Password"
    @submit="verifyPassword"
    :submitDisabled="!confirmedPassword"
    :submitLoading="confirmPasswordLoading"
    :persistent="false"
  >
    <span v-if="description"> {{ description }} </span>
    <v-text-field
      v-model="confirmedPassword"
      placeholder="Password"
      autofocus
      type="password"
      class="test-confirm-password mt-4"
      @keypress.enter="confirmedPassword && verifyPassword()"
      variant="outlined"
    />
  </OareDialog>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import sl from '@/serviceLocator';
import { INVALID_CREDENTIAL_CODES } from '../authErrors';

export default defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      required: false,
    },
  },
  emits: ['update:modelValue', 'reauthenticated'],
  setup(_, { emit }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const confirmPasswordLoading = ref(false);
    const confirmedPassword = ref('');

    const verifyPassword = async () => {
      confirmPasswordLoading.value = true;
      try {
        await server.reauthenticateUser(confirmedPassword.value);
        confirmedPassword.value = '';
        emit('reauthenticated');
        emit('update:modelValue', false);
      } catch (err) {
        if (INVALID_CREDENTIAL_CODES.includes((err as any)?.code)) {
          actions.showErrorSnackbar(
            'The password you have provided is invalid.',
            err as Error
          );
        } else {
          actions.showErrorSnackbar(
            'Error verifying your password. Please try again.',
            err as Error
          );
        }
      } finally {
        confirmPasswordLoading.value = false;
      }
    };
    return {
      confirmPasswordLoading,
      confirmedPassword,
      verifyPassword,
    };
  },
});
</script>
